import { FC } from 'react';

import BeneficiarySellModalHeader from './components/BeneficiarySellModalHeader';
import BeneficiarySellModalBody from './components/BeneficiarySellModalBody';

const BeneficiarySellModal: FC = () => (
  <>
    <BeneficiarySellModalHeader />
    <BeneficiarySellModalBody />
  </>
);

export default BeneficiarySellModal;
